import { render, staticRenderFns } from "./NewCustomersList.vue?vue&type=template&id=46dfd1ca&"
import script from "./NewCustomersList.vue?vue&type=script&lang=ts&"
export * from "./NewCustomersList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports